import {Injectable} from '@angular/core';
import * as $ from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() {
  }

  success(message) {
    this.basic().append($('<div>', {
      class: 'notification is-success',
      text: message
    })).appendTo('body');
  }

  basic() {
    return $('<div>', {
      id: "temp-not-modal",
      class: 'container modal is-active'
    }).append($('<div>', {
      class: 'delete',
      onclick: '$("#temp-not-modal").remove();'
    }));

  }

  remove(elem) : void {
    $(elem).remove();
  }
}

